var render = function render(){var _vm=this,_c=_vm._self._c;return _c('common-header',{attrs:{"name":"首页","actions":_vm.compActions,"link":_vm.link,"is-fav":_vm.favObj.isfav,"user-name":_vm.compUserName,"isHasIpv6":_vm.isHasIpv6},on:{"btn:click":_vm.handleClick,"opt:change":_vm.handleOptChange}},[_c('div',{staticClass:"qa-title"},[_vm._v(_vm._s(_vm.titleText))])])
}
var staticRenderFns = []

export { render, staticRenderFns }